import { Injectable, OnDestroy, DOCUMENT } from "@angular/core";
import {
  Router,
  NavigationStart,
  NavigationEnd,
  NavigationError,
  NavigationCancel,
  RoutesRecognized,
  RouteConfigLoadStart,
} from "@angular/router";
import {
  MenuItem,
  EnumMenuItem,
  UserModel,
  EnumSegregationType,
} from "../../services/api.client.generated";
import { ViewSaved } from "./ViewSaved";
import { ToastService } from "../../services/toast.service";

import { Inject } from "@angular/core";
import { EnumPrivilege } from "../../models/enums/privileges";
import { AllowedActions } from "./AllowedActions";
import { BehaviorSubject, Subject, Subscription } from "rxjs";
import { filter } from "rxjs/operators";
import { ModalData } from "./ModalData";

@Injectable()
export class Globals implements OnDestroy {
  login = false;
  openMainMenu = false;
  userLogged = false;
  loader: boolean;
  activeMenu: MenuItem = new MenuItem();
  user: any;
  views!: Array<ViewSaved>;
  comment!: string;
  showComment: BehaviorSubject<boolean> = new BehaviorSubject<boolean>(false);
  private requestsToIgnoreModal: Array<string> = new Array<string>();
  private routerSubscription!: Subscription;
  modalData: ModalData = {
    showModal: false,
    comment: new Subject<string>(),
  };

  functionDic: any = {
    partGet: [
      "id",
      "name",
      "segregationType",
      "partNumber",
      "nickName",
      "oemPartNumber",
      "isKit",
      "isActive",
      "customerName",
      "maximumCycles",
      "customerId",
      "procedureId",
      "oEMId",
      "createdOn",
      "createdByName",
      "lastUpdatedOn",
      "lastUpdatedByName",
      "term",
      "pageNumber",
      "pageSize",
      "sortAscending",
      "version",
    ],
    partExport: [
      "id",
      "name",
      "segregationType",
      "partNumber",
      "oemPartNumber",
      "isKit",
      "isActive",
      "maximumCycles",
      "createdOn",
      "createdByName",
      "term",
      "pageNumber",
      "pageSize",
      "sortAscending",
      "version",
    ],
    history: [
      "purchaseId",
      "workOrderItemNumber",
      "customer",
      "location",
      "serialNumber",
      "purchaseOrderNumber",
      "qty",
      "scheduledStartDate",
      "scheduledEndDate",
      "actualStartDate",
      "actualEndDate",
      "product",
      "procedure",
      "status",
      "disposition",
      "term",
      "pageNumber",
      "pageSize",
      "sortAscending",
      "version",
    ],
    procedureStepTemplateGet: [
      "id",
      "title",
      "text",
      "term",
      "pageNumber",
      "pageSize",
      "sortAscending",
      "version",
    ],
    procedureTypeGet: [
      "id",
      "name",
      "term",
      "pageNumber",
      "pageSize",
      "sortAscending",
      "version",
    ],
    procedureGet: [
      "id",
      "name",
      "procedureTypeName",
      "duration",
      "durationType",
      "revision",
      "createdFullName",
      "createdOn",
      "lastUpdatedFullName",
      "lastUpdatedOn",
      "term",
      "pageNumber",
      "pageSize",
      "sortAscending",
      "version",
    ],
    export: [
      "id",
      "name",
      "procedureTypeName",
      "duration",
      "durationType",
      "revision",
      "createdFullName",
      "createdOn",
      "lastUpdatedFullName",
      "lastUpdatedOn",
      "term",
      "pageNumber",
      "pageSize",
      "sortAscending",
      "version",
    ],
    userGet: [
      "id",
      "firstName",
      "lastName",
      "userName",
      "title",
      "supervisorName",
      "primaryPhone",
      "email",
      "roles",
      "isActive",
      "isAnswerUser",
      "createdOn",
      "locationName",
      "term",
      "pageNumber",
      "pageSize",
      "sortAscending",
      "version",
    ],
    roleGet: [
      "id",
      "name",
      "isCertificationRole",
      "parentRoles",
      "assignedUsers",
      "createdOn",
      "createdByName",
      "lastUpdatedOn",
      "lastUpdatedByName",
      "term",
      "pageNumber",
      "pageSize",
      "sortAscending",
      "version",
    ],
    customerGet: [
      "id",
      "name",
      "address",
      "phone",
      "primaryContactUserId",
      "secondaryContactUserId",
      "locationId",
      "isActive",
      "primaryContactUserFullName",
      "secondaryContactUserFullName",
      "locationName",
      "createdFullName",
      "createdOn",
      "status",
      "term",
      "pageNumber",
      "pageSize",
      "sortAscending",
      "version",
    ],
    trainingCertification: [
      "userId",
      "employeeName",
      "certificationName",
      "certificationFromDate",
      "certificationToDate",
      "status",
      "term",
      "pageNumber",
      "pageSize",
      "sortAscending",
      "version",
    ],
    locationGet: [
      "parentId",
      "id",
      "internalAddress",
      "name",
      "createdFullName",
      "createdOn",
      "address1",
      "city",
      "state",
      "postalcode",
      "country",
      "phone",
      "parentName",
      "timezoneDescription",
      "address2",
      "isActive",
      "status",
      "partId",
      "term",
      "pageNumber",
      "pageSize",
      "sortAscending",
      "version",
    ],
    product: [
      "submittedDate",
      "company",
      "submittedByFullName",
      "divisionFab",
      "partKitNo",
      "segregationType",
      "procedureId",
      "procedureName",
      "productName",
      "representative",
      "revision",
      "equipmentCost",
      "materialCost",
      "salesTax",
      "totalPrice",
      "cycleTime",
      "lastUpdateOn",
      "lastUpdatedBy",
      "term",
      "pageNumber",
      "pageSize",
      "sortAscending",
      "version",
    ],
    paged: [
      "submittedDate",
      "company",
      "submittedByFullName",
      "divisionFab",
      "partKitNo",
      "segregationType",
      "procedureId",
      "procedureName",
      "productName",
      "representative",
      "revision",
      "equipmentCost",
      "materialCost",
      "salesTax",
      "totalPrice",
      "cycleTime",
      "lastUpdateOn",
      "lastUpdatedBy",
      "term",
      "pageNumber",
      "pageSize",
      "sortAscending",
      "version",
    ],
    purchaseOrderGet: [
      "id",
      "name",
      "customerReferencePO",
      "invoicedBalance",
      "uninvoicedBalance",
      "balance",
      "customerName",
      "openDate",
      "closeDate",
      "totalPurchaseLimit",
      "unusedAmount",
      "revision",
      "status",
      "term",
      "pageNumber",
      "pageSize",
      "sortAscending",
      "version",
    ],
    view: [
      "id",
      "name",
      "customerReferencePO",
      "invoicedBalance",
      "uninvoicedBalance",
      "balance",
      "customerName",
      "openDate",
      "closeDate",
      "totalPurchaseLimit",
      "unusedAmount",
      "revision",
      "status",
      "term",
      "pageNumber",
      "pageSize",
      "sortAscending",
      "version",
    ],

    purchaseGet: [
      "id",
      "mttn",
      "purchaseOrderProductName",
      "statusId",
      "createdOn",
      "term",
      "pageNumber",
      "pageSize",
      "sortAscending",
      "version",
    ],
    invoiceGet: [
      "id",
      "customerName",
      "description",
      "invoiceNumber",
      "dueDate",
      "createdOn",
      "createdByName",
      "lastUpdatedOn",
      "lastUpdatedByName",
      "amount",
      "statusId",
      "term",
      "pageNumber",
      "pageSize",
      "sortAscending",
      "version",
    ],
    equipmentMaintenanceGet: [
      "id",
      "locationName",
      "createdOn",
      "createdFullName",
      "assignedToFullName",
      "troubleState",
      "maintenanceTask",
      "pemLastCompletedDate",
      "frequencyField",
      "comments",
      "statusName",
      "term",
      "pageNumber",
      "pageSize",
      "sortAscending",
      "version",
    ],
    documentGet: [
      "id",
      "name",
      "revision",
      "lastUpdatedOn",
      "lastUpdatedFullName",
      "term",
      "pageNumber",
      "pageSize",
      "sortAscending",
      "version",
    ],
    helpGet: [
      "id",
      "friendlyURL",
      "title",
      "roles",
      "term",
      "pageNumber",
      "pageSize",
      "sortAscending",
      "version",
    ],
    menu: ["pageNumber", "pageSize", "Sort[]", "Filters[]", "version"],
    download: [
      "submittedDate",
      "company",
      "submittedByFullName",
      "divisionFab",
      "partKitNo",
      "segregationType",
      "procedureId",
      "procedureName",
      "productName",
      "representative",
      "revision",
      "equipmentCost",
      "materialCost",
      "salesTax",
      "totalPrice",
      "cycleTime",
      "lastUpdateOn",
      "lastUpdatedBy",
      "term",
      "pageNumber",
      "pageSize",
      "sortAscending",
      "version",
    ],
  };

  constructor(
    private router: Router,
    private toastr: ToastService,
    @Inject(DOCUMENT) document: any,
  ) {
    this.loadUserFromLocalStorage();
    this.setActiveMenuItem(router);
    this.loader = true;
  }

  setActiveMenuItem(router: Router) {
    this.routerSubscription = router.events
      .pipe(filter((event) => event instanceof NavigationEnd))
      .subscribe((event: NavigationEnd) => {
        if (this.user !== undefined) {
          const urlTocheck = event.url
            .split("?")[0]
            .split("/")
            .pop()
            ?.toLowerCase();
          if (!urlTocheck) return;

          let matched: MenuItem | null = null;
          for (let i = this.user.roles.length - 1; i >= 0; i--) {
            const exact = this.user.roles[i].menus.find(
              (x: any) => x.url.toLowerCase() === urlTocheck,
            );
            if (exact) {
              matched = exact;
              break;
            }

            const partial = this.user.roles[i].menus.find((x: any) =>
              urlTocheck.startsWith(x.url.toLowerCase().replace(/s$/, "")),
            );
            if (partial && !matched) {
              matched = partial;
            }
          }
          if (matched) {
            this.activeMenu = matched;
          }
        }
      });
  }

  loadUserFromLocalStorage() {
    if (localStorage.user === undefined || localStorage.user === undefined) {
      delete localStorage.user;
      delete localStorage.token;
    }

    if (localStorage.user !== undefined) {
      this.userLogged = true;
    }
    if (localStorage.user !== undefined) {
      this.user = JSON.parse(localStorage.user);
      this.user.timezoneSTDPipe = this.getOffset()["STD"];
      this.user.timezoneDSTPipe = this.getOffset()["DST"];
    }
  }

  showLoader(isOn: any) {
    setTimeout(() => {
      this.loader = isOn;
    }, 100);
  }

  hasPrivilege(controllerEnum: any, privilege: any) {
    const privileges = this.user.privileges[controllerEnum];
    if (privileges === undefined || privileges === null) {
      return false;
    }
    const ret = privileges.indexOf(privilege) > -1;
    return ret;
  }

  getCalendarDefault() {
    const en = {
      firstDayOfWeek: 0,
      dayNames: [
        "Sunday",
        "Monday",
        "Tuesday",
        "Wednesday",
        "Thursday",
        "Friday",
        "Saturday",
      ],
      dayNamesShort: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
      dayNamesMin: ["Su", "Mo", "Tu", "We", "Th", "Fr", "Sa"],
      monthNames: [
        "January",
        "February",
        "March",
        "April",
        "May",
        "June",
        "July",
        "August",
        "September",
        "October",
        "November",
        "December",
      ],
      monthNamesShort: [
        "Jan",
        "Feb",
        "Mar",
        "Apr",
        "May",
        "Jun",
        "Jul",
        "Aug",
        "Sep",
        "Oct",
        "Nov",
        "Dec",
      ],
      today: "Today",
      clear: "Clear",
      dateFormat: "yyy-mm-dd",
    };
    return en;
  }

  getEnumPrivileges(controllerEnum: any): AllowedActions {
    const allowedActions = new AllowedActions({
      canCreate: this.hasPrivilege(controllerEnum, EnumPrivilege.CanCreate),
      canActivate: this.hasPrivilege(controllerEnum, EnumPrivilege.CanActivate),
      canDelete: this.hasPrivilege(controllerEnum, EnumPrivilege.CanDelete),
      canEdit: this.hasPrivilege(controllerEnum, EnumPrivilege.CanEdit),
      canRead: this.hasPrivilege(controllerEnum, EnumPrivilege.CanRead),
    });

    return allowedActions;
  }

  getSingularMenuName(menuItem: any) {
    let name = EnumMenuItem[menuItem];
    if (menuItem === EnumMenuItem.StepTemplates) {
      name = "ProcedureStepTemplate";
    }
    if (name) {
      return name.replace(/s$/, "");
    }
    return name;
  }

  updateLogin(val: any) {
    this.login = val;
  }

  updateUserLogged(val: any) {
    this.userLogged = val;
  }

  updateUser(val: any) {
    this.user = val;
    this.user.timezoneSTDPipe = this.getOffset()["STD"];
    this.user.timezoneDSTPipe = this.getOffset()["DST"];
    localStorage.setItem("user", JSON.stringify(val));
  }

  getCurrentUser() {
    return this.user;
  }

  getOffset() {
    if (this.user.timeZone === undefined) {
      return {
        DST: "",
        STD: "",
      };
    }
    const offset = this.user.timeZone.offset;
    let intPart = Math.floor(offset);
    let fraction = (Math.floor((offset - Math.floor(offset)) * 100) * 60) / 100;
    let fractionPart = "";
    if (fraction > 0) {
      fractionPart = ":" + fraction.toString();
      if (fraction.toString().length === 1) {
        fractionPart += "0";
      }
    }
    // return 'GMT' + intPart + fractionPart;

    return {
      DST: "GMT" + intPart.toString() + fractionPart,
      STD:
        "GMT" +
        (intPart - this.user.timeZone.useDalightSavings).toString() +
        fractionPart,
    };
  }

  getLogin() {
    return this.login;
  }

  hasRole(roleName: any) {
    if (this.user.roles.length > 0) {
      const index = this.user.roles.findIndex(
        (role: any) => role.name === roleName,
      );
      if (index > -1) {
        return true;
      }
    }

    return false;
  }

  hasLocation(locationId: any) {
    return this.user.locationId === locationId;
  }

  addRequestToIgnore(requestToIgnore: string): void {
    this.requestsToIgnoreModal.push(requestToIgnore);
  }

  removeRequestToIgnore(requestToIgnore: string): void {
    let indexOfRequestToRemove = this.requestsToIgnoreModal.findIndex(
      (s) => s === requestToIgnore,
    );
    this.requestsToIgnoreModal.splice(indexOfRequestToRemove, 1);
  }

  isRequestNotOnListToIgnore(url: string): boolean {
    let requestIsNotOnList = true;
    this.requestsToIgnoreModal.map((requestToIgnore) => {
      if (url.includes(requestToIgnore)) {
        requestIsNotOnList = false;
      }
    });

    return requestIsNotOnList;
  }

  getTopLevelLocations() {
    return [
      { label: "Chandler", value: "Chandler" },
      { label: "Hillsboro", value: "Hillsboro" },
      { label: "Kiryat Gat", value: "Kiryat Gat" },
      { label: "Naas", value: "Naas" },
      { label: "Richardson", value: "Richardson" },
    ];
  }

  getTopLevelStatus() {
    return [
      { label: "Approved", value: "Approved" },
      { label: "In Progress", value: "In Progress" },
      { label: "Complete", value: "Complete" },
      { label: "Cancelled", value: "Cancelled" },
      { label: "Pending", value: "Pending" },
      { label: "Rejected", value: "Rejected" },
      { label: "Open", value: "Open" },
      { label: "Closed", value: "Closed" },
      { label: "Requested", value: "Requested" },
      { label: "Assigned", value: "Assigned" },
      { label: "Waiting to Start", value: "Waiting to Start" },
      { label: "Scheduled", value: "Scheduled" },
    ];
  }

  getYesNoArray() {
    return [
      { label: "Yes", value: true },
      { label: "No", value: false },
    ];
  }

  getSegregationTypes() {
    return [
      { label: "Cu", value: EnumSegregationType.CU },
      { label: "Non-Cu", value: EnumSegregationType.NONCU },
      { label: "Deseg", value: EnumSegregationType.DESEG },
    ];
  }

  ngOnDestroy() {
    if (this.routerSubscription) {
      this.routerSubscription.unsubscribe();
    }
  }
}
